'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _seekSeekClassificationsHierarchy = require('@seek/seek-classifications-hierarchy');

var _seekSeekClassificationsHierarchy2 = _interopRequireDefault(_seekSeekClassificationsHierarchy);

var _workTypeHierarchy = require('./work-type-hierarchy');

var _workTypeHierarchy2 = _interopRequireDefault(_workTypeHierarchy);

var _slugify = require('./slugify');

var _slugify2 = _interopRequireDefault(_slugify);

var companyidRegex = /.*-(\d+)$/;
var slugifiableLocationRegex = /^[a-z][a-z0-9\s-'\(\)&,]+[a-z0-9]$/i;

var slugsById = {
  worktype: {},
  classification: {},
  subclassification: {}
};

var idsBySlug = {
  worktype: {},
  classification: {},
  subclassification: {}
};

// Work types
for (var workType in _workTypeHierarchy2['default']) {
  slugsById.worktype[_workTypeHierarchy2['default'][workType]] = workType;
  idsBySlug.worktype[workType] = _workTypeHierarchy2['default'][workType];
}

// Classification + Subclassification
function addSubclassification(currentSubclassificationId, newClassificationId, newSubclassificationId) {
  currentSubclassificationId = currentSubclassificationId || {};

  return _extends({}, currentSubclassificationId, _defineProperty({}, newClassificationId, newSubclassificationId));
}

_seekSeekClassificationsHierarchy2['default'].forEach(function (classification) {
  var classificationSlug = (0, _slugify2['default'])(classification.description);

  slugsById.classification[classification.id] = classificationSlug;
  idsBySlug.classification[classificationSlug] = '' + classification.id;

  classification.subClassifications.forEach(function (subClassification) {
    var subclassificationSlug = (0, _slugify2['default'])(subClassification.description);

    slugsById.subclassification[subClassification.id] = subclassificationSlug;
    idsBySlug.subclassification[subclassificationSlug] = addSubclassification(idsBySlug.subclassification[subclassificationSlug], '' + classification.id, '' + subClassification.id);
  });
});

function getSlugById(param, id) {
  if (param === 'where' && slugifiableLocationRegex.test(id)) {
    return id.replace(/-/g, '+').replace(/ /g, '-');
  }

  if (param === 'graduatesearch') {
    return id === 'true' ? 'graduate' : null;
  }

  return typeof slugsById[param] === 'undefined' || typeof slugsById[param][id] === 'undefined' ? null : slugsById[param][id];
}

function getIdBySlug(param, slug) {
  if (param === 'where') {
    return slug.replace(/\-/g, ' ').replace(/\+/g, '-');
  }

  if (param === 'companyid') {
    var match = slug.match(companyidRegex);

    return match === null ? null : match[1];
  }

  if (param === 'graduatesearch') {
    return slug === 'graduate' ? 'true' : null;
  }

  var normalisedSlug = slug.toLowerCase();

  return typeof idsBySlug[param] === 'undefined' || typeof idsBySlug[param][normalisedSlug] === 'undefined' ? null : idsBySlug[param][normalisedSlug];
}

function convertSlugsToIds(params) {
  var result = {};

  if (typeof params.classification !== 'undefined') {
    var id = getIdBySlug('classification', params.classification);

    if (id !== null) {
      result.classification = id;
    }
  }

  if (typeof params.subclassification !== 'undefined') {
    var ids = getIdBySlug('subclassification', params.subclassification);

    if (ids !== null) {
      var classificationIds = Object.keys(ids);

      if (typeof result.classification === 'undefined') {
        if (classificationIds.length === 1) {
          result.classification = classificationIds[0];
          result.subclassification = ids[result.classification];
        }
      } else {
        if (result.classification in ids) {
          result.subclassification = ids[result.classification];
        }
      }
    }
  }

  for (var param in params) {
    if (param !== 'classification' && param !== 'subclassification') {
      var id = getIdBySlug(param, params[param]);

      if (id !== null) {
        result[param] = id;
      }
    }
  }

  return result;
}

exports['default'] = {
  getSlugById: getSlugById,
  getIdBySlug: getIdBySlug,
  convertSlugsToIds: convertSlugsToIds
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/hierarchy/slugs.js
 ** module id = 539
 ** module chunks = 0
 **/